module.exports = __webpack_public_path__ + "img/support_system@3x.16eff100.png";